import { render, staticRenderFns } from "./LobbyTeam.vue?vue&type=template&id=5e18139a&scoped=true&"
import script from "./LobbyTeam.vue?vue&type=script&lang=js&"
export * from "./LobbyTeam.vue?vue&type=script&lang=js&"
import style0 from "./LobbyTeam.vue?vue&type=style&index=0&id=5e18139a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e18139a",
  null
  
)

component.options.__file = "LobbyTeam.vue"
export default component.exports